<div class="dashboard-container">
  <!-- Cards de bienvenida y tareas pendientes -->
  <div class="welcome-cards" [class.full-width]="!hasVisibleTasksCard" [class.has-tasks]="hasVisibleTasksCard">
    <!-- Card de bienvenida -->
    <div class="welcome-card">
      <div class="card-date">
        {{ currentDate | date : "EEEE d 'de' MMMM 'del' yyyy" }}
      </div>
      <h2 class="card-greeting">
        <span class="greeting-desktop"
          >¡Hola {{ authUser.name || "Usuario" }}!</span
        >
        <span class="greeting-mobile"
          >Bienvenida {{ authUser.name || "Usuario" }}</span
        >
      </h2>
      <p class="card-subtitle">Bienvenido a Phoenix Executive</p>
    </div>

    <!-- Versión mobile sin card -->
    <div class="welcome-mobile-only">
      <div class="mobile-date">
        {{ currentDate | date : "EEEE d 'de' MMMM 'del' yyyy" }}
      </div>
      <h2 class="mobile-greeting">
        Bienvenida {{ authUser.name || "Usuario" }}
      </h2>
    </div>

    <!-- Card de próxima cita - Muestra 3 días antes de la cita -->
    <div class="tasks-card appointment-card" *ngIf="showAppointmentCard && !isThreeDaysBeforeWeek3" >
      <div class="card-background"></div>
      <div class="card-red-line"></div>
      <div class="card-content">
        <div class="text-content">
          <p class="card-title">{{ getAppointmentCardText() }}</p>
          <p class="card-description">Continúa con tu plan de vida</p>
        </div>
        <button class="card-button" (click)="scrollToCalendar()">
          Ver agenda
        </button>
      </div>
    </div>

    <!-- Card de tareas pendientes -->
    <!-- Card de mentor - Muestra 3 días antes de la semana 3 o 6 -->
    <div class="tasks-card" *ngIf="isThreeDaysBeforeWeek3">
      <div class="card-red-line"></div>
      <div class="card-content">
        <div class="text-content">
          <h3 class="card-title">Agenda con tu mentor</h3>
          <p class="card-description">
            Tu segunda sesión y continua con tu plan de vida
          </p>
        </div>
        <button class="card-button" (click)="goToMiMentorFromCard()">
          Agenda ahora
        </button>
      </div>
    </div>

    <!-- Card de tareas pendientes - Solo si hay objetivos o actividades pendientes -->
    <div
      class="tasks-card"
      *ngIf="!isThreeDaysBeforeWeek3 && hasPendingObjectivesOrActivities"
    >
      <div class="card-red-line"></div>
      <div class="card-content">
        <div class="text-content">
          <span class="card-title-mobile">Tareas</span>
          <span class="card-subtitle-mobile">Pendientes</span>
          <h3 class="card-title">Tareas pendientes</h3>
          <p class="card-description">Visualiza aqui tus pendientes</p>
        </div>
        <button class="card-button" (click)="viewPendingTasks()">
          Ver ahora
        </button>
      </div>
      <!-- Elementos decorativos para móvil -->
      <div class="tasks-card-mobile-decorations">
        <div class="red-circle-decoration"></div>
        <div class="hands-document-image"></div>
      </div>
    </div>
  </div>

  <!-- Banner móvil -->
  <div *ngIf="showSalaryBanner" class="salary-banner mobile-banner">
    <div class="banner-content">
      <div class="banner-background"></div>
      <div class="banner-icon"></div>
      <div class="banner-text">
        <h2 class="banner-title">Agenda con tu mentor</h2>
      </div>
      <button class="banner-button" (click)="goToMiMentorFromSalary()">
        AQUI
      </button>
      <button class="banner-close" (click)="closeSalaryBanner()">×</button>
    </div>
  </div>

  <!-- Cards de resumen para móvil -->
  <!-- <div class="summary-cards mobile-cards"> -->
  <!-- Card 1: Objetivos completados (Verde) -->
  <!-- <div class="mobile-summary-card green-card">
      <div class="mobile-card-icon">
        <i class="fa-solid fa-trophy"></i>
      </div>
      <div class="mobile-card-content">
        <h3 class="mobile-card-title">Objetivos</h3>
        <p class="mobile-card-value">{{ totalObjetivosCompletados }}/{{ totalObjetivos }}</p>
      </div>
    </div> -->

  <!-- Card 2: Hora de experto (Púrpura) -->
  <!-- <div class="mobile-summary-card purple-card locked-card">
      <div class="mobile-card-icon">
        <i class="fa-solid fa-lock"></i>
      </div>
      <div class="mobile-card-content">
        <h3 class="mobile-card-title">Hora de experto</h3>
        <p class="mobile-card-value">{{ horasExpertos }}/{{ horasTotalesExpertos }} </p>
      </div>
    </div> -->

  <!-- Card 3: Hora de mentor (Azul claro) -->
  <!-- <div class="mobile-summary-card light-blue-card">
      <div class="mobile-card-icon">
        <i class="fa-solid fa-clock"></i>
      </div>
      <div class="mobile-card-content">
        <h3 class="mobile-card-title">Hora de mentor</h3>
        <p class="mobile-card-value">{{ horasMentores }}/{{ horasTotalesMentores }}</p>
      </div>
    </div> -->
  <!-- </div> -->

  <!-- Banner de felicitaciones por salario alto (Desktop) -->
  <div *ngIf="showSalaryBanner" class="salary-banner desktop-banner">
    <div class="banner-content">
      <div class="banner-background"></div>
      <div class="banner-icon"></div>
      <div class="banner-text">
        <h2 class="banner-title">Agenda con tu mentor</h2>
      </div>
      <button class="banner-button" (click)="goToMiMentorFromSalary()">
        AQUI
      </button>
      <button class="banner-close" (click)="closeSalaryBanner()">×</button>
    </div>
  </div>

  <!-- Banner de "Conoce a tu Mentor" - Prioridad alta -->
  <div class="salary-banner mentor-banner" *ngIf="showExecutiveModal && !showPhoenixSessionsBanner && !showGraduationBanner">
    <div class="banner-background"></div>
    <div class="banner-icon"></div>
    <div class="banner-content">
      <div class="banner-text">
        <h2 class="banner-title">Conoce a tu mentor</h2>
        <p class="banner-subtitle">
          Tambien podras encontrar su perfil en el menu izquierdo
        </p>
      </div>
      <button class="banner-button" (click)="goToMiMentor()">Conocelo Aqui</button>
    </div>
  </div>

  <!-- Banner Tip Phoenix - Se muestra si no hay banner de mentor -->
  <div class="salary-banner desktop-banner" *ngIf="showTipPhoenixBanner && !showExecutiveModal && !showPhoenixSessionsBanner && !showGraduationBanner" >
    <div class="banner-content">
      <div class="banner-text">
        <h2 class="banner-title">Tip Phoenix</h2>
        <p class="banner-subtitle">
          Este es el mejor momento para conversar con un experto y profundizar
          en tus prioridades.
        </p>
      </div>
      <button class="banner-button" (click)="goToMentors()">
        Agendar ahora
      </button>
    </div>
  </div>

  <!-- Banner de Graduación -->
  <div
    *ngIf="showGraduationBanner && !showPhoenixSessionsBanner"
    class="graduation-banner"
  >
    <div class="graduation-banner-background">
      <div class="graduation-banner-content">
        <div class="graduation-banner-text">
          <h2 class="graduation-banner-title">
            Graduación Phoenix: Celebremos juntos tu gran logro
          </h2>
          <p class="graduation-banner-description">
            Un evento único para reconocer el esfuerzo, la dedicación y la
            transformación de cada participante. Es momento de compartir,
            inspirar y mirar hacia el futuro con orgullo y propósito.
          </p>
        </div>
        <button class="graduation-banner-button" (click)="confirmGraduation()">
          Confirma aqui
        </button>
      </div>
    </div>
  </div>

  <!-- Sección de progreso -->
  <div class="progress-section">
    <h2 class="progress-title">Tu progreso</h2>
    <p class="progress-subtitle">
      Conoce aquí tu progreso en Phoenix Executive
    </p>
  </div>

  <!-- Banner de análisis profundo -->
  <div class="deep-analysis-banner" *ngIf="showDeepAnalysisBanner">
    <div class="banner-icon-container">
      <img src="/assets/img/alarm-clock-icon.svg" alt="Alarm clock" class="banner-alarm-icon" />
    </div>
    <div class="banner-text">
      <span
        >Tienes hasta el {{ deepAnalysisDeadlineDate }} para terminar tu análisis profundo, culmina esta tarea
      </span>
    </div>
    <button class="banner-link-button" (click)="goToMiMentor()">AQUI</button>
  </div>

  <!-- Sección de Progress Steps -->
  <div class="progress-steps-section">
    <div class="progress-steps">
      <div
        class="step"
        *ngFor="let step of progressSteps; let i = index"
        [class.completed]="step.status === 'completed'"
        [class.in-progress]="step.status === 'in-progress'"
        [class.pending]="step.status === 'pending'"
      >
        <div class="step-content">
          <div class="step-circle">
            <span class="step-number">{{ step.number }}</span>
          </div>

          <!-- Línea conectora independiente a la derecha (excepto para el último step) -->
          <div
            class="step-connector"
            *ngIf="i < progressSteps.length - 1"
          ></div>
        </div>

        <div class="step-info">
          <h3 class="step-title">{{ step.title }}</h3>
          <div class="step-status">
            <span class="status-text">{{ step.statusText }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Banner de Phoenix Sessions -->
  <div *ngIf="showPhoenixSessionsBanner" class="phoenix-sessions-banner">
    <div class="banner-background">
      <!-- Vista Desktop -->
      <div class="banner-content desktop-content">
        <div class="banner-text">
          <h2 class="banner-title">
            Phoenix Sessions: El punto de encuentro de líderes
            <span class="c-level-highlight">C-Level</span>
          </h2>
          <p class="banner-description">
            Un exclusivo evento de networking y reflexión estratégica, diseñado
            para que los ejecutivos más influyentes se conecten, compartan
            experiencias y exploren juntos nuevas oportunidades de impacto y
            crecimiento.
          </p>
        </div>
        <div class="banner-actions">
          <button class="banner-button" (click)="confirmAttendance()">
            CONFIRMA TU ASISTENCIA
          </button>
          <p class="banner-subtitle">VIVE EL MEJOR EVENTO DEL AÑO</p>
        </div>
      </div>
      
      <!-- Vista Mobile -->
      <div class="banner-content mobile-content">
        <div class="mobile-graphic">
          <div class="mobile-circle">
            <svg class="people-icons" width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <!-- Persona izquierda -->
              <circle cx="25" cy="25" r="10" fill="white"/>
              <path d="M10 60C10 50 15 42 22 38C24 37 26 37 28 38C33 42 38 50 38 60" stroke="white" stroke-width="3" stroke-linecap="round" fill="none"/>
              <!-- Persona derecha -->
              <circle cx="55" cy="25" r="10" fill="white"/>
              <path d="M42 60C42 50 47 42 54 38C56 37 58 37 60 38C65 42 70 50 70 60" stroke="white" stroke-width="3" stroke-linecap="round" fill="none"/>
            </svg>
          </div>
        </div>
        <div class="banner-text">
          <h2 class="banner-title">Phoenix Session</h2>
          <p class="banner-subtitle-mobile">Líderes C-Level: conecta y crea oportunidades</p>
        </div>
        <div class="banner-actions">
          <button class="banner-button" (click)="confirmAttendance()">
            Confirma tu asistencia
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Mensaje cuando no hay objetivos -->
  <div *ngIf="totalObjetivos === 0" class="no-objectives-message">
    <div class="message-content">
      <span class="checkmark-icon">✓</span>
      <p class="message-text">
        Aún no tienes objetivos registrados. Empieza creando el primero y da el
        primer paso hacia tus metas.
      </p>
    </div>
  </div>

  <!-- Mensaje informativo (oculto por defecto, similar a ObjectivesComponent) -->
  <div *ngIf="!messageHide" class="message">
    <div class="message-text">
      <span class="icon-info"></span>
      <p>
        Completa la priorización con tu mentor para tener una mejor guía de qué
        objetivos crear.
      </p>
    </div>
    <div class="message-close" (click)="hideMessage()">
      <span class="icon-close">×</span>
    </div>
  </div>

  <!-- Botones de Objetivos -->
  <div class="objectives-buttons">
    <button class="btn-view-objectives" (click)="viewObjectives()">
      Ver objetivos
    </button>
    <!-- <button class="btn-add-objective" (click)="addObjective()">
      <span class="btn-text-full">Agregar objetivo</span>
      <span class="btn-text-mobile">Agregar</span>
      <i class="fas fa-plus"></i>
    </button> -->
  </div>

  <!-- Componente de Progreso, Objetivos y Actividades -->
  <app-table
    [data]="objetivosOriginales"
    [showFilters]="false"
    (itemDeleted)="onObjetivoDeleted($event)"
    (designResponsive)="onDesignResponsive($event)"
    (stateChanged)="onStateChanged()"
    (reloadObjectives)="reloadObjectivesList()"
  ></app-table>

  <!-- Sección de Calendario -->
  <div class="calendario-card">
    <div class="card-header">
      <h2>Calendario</h2>
      <!-- Resumen de próximas citas -->
      <!-- <div class="upcoming-appointments">
        <h3>Próximas citas</h3>
        <div class="appointments-list" *ngIf="getUpcomingAppointments().length > 0">
          <div class="appointment-item" *ngFor="let appointment of getUpcomingAppointments()">
            <div class="appointment-info">
              <span class="appointment-date">{{ appointment.date | date:'dd/MM/yyyy' }}</span>
              <span class="appointment-time">{{ appointment.time }}</span>
              <span class="coach-name">{{ appointment.coach.name }}</span>
              <span class="coach-type">{{ appointment.coach.type.name }}</span>
            </div>
          </div>
        </div>
        <div class="no-appointments" *ngIf="getUpcomingAppointments().length === 0">
          <p>No tienes citas programadas</p>
          <button class="schedule-btn" (click)="goToMentors()">Agendar cita</button>
        </div>
      </div> -->
    </div>

    <div class="calendario-container">
      <div class="calendario-content">
        <div class="calendario-layout">
          <!-- Calendario Semanal (Principal) -->
          <div class="calendario-semanal">
            <div class="calendar-header">
              <div class="view-toggles">
                <button
                  class="view-btn mobile-hidden"
                  [class.active]="currentView === 'month'"
                  (click)="changeToMonthView()"
                >
                  Mes
                </button>
                <button
                  class="view-btn mobile-hidden"
                  [class.active]="currentView === 'week'"
                  (click)="changeView('week')"
                >
                  Semana
                </button>
                <button
                  class="view-btn"
                  [class.active]="isDayViewActive()"
                  (click)="changeView('day')"
                >
                  Día
                </button>
                <!-- <button class="view-btn" [class.active]="isTodaySelected()" (click)="goToToday()">Hoy</button> -->
              </div>
              <div class="calendar-nav" *ngIf="currentView !== 'month'">
                <button
                  class="nav-btn"
                  (click)="navigateWeek(-1)"
                  aria-label="Semana anterior"
                >
                  &#8592;
                </button>
                <span class="current-week">{{ getCurrentWeekRange() }}</span>
                <button
                  class="nav-btn"
                  (click)="navigateWeek(1)"
                  aria-label="Semana siguiente"
                >
                  &#8594;
                </button> 
              </div>
            </div>

            <div
              class="calendar-grid"
              [class.day-view]="currentView === 'day'"
              [class.month-view]="currentView === 'month'"
            >
              <div class="time-column">
                <div class="time-header"></div>
                <div class="time-slot" *ngFor="let hour of timeSlots">
                  {{ hour }}
                </div>
              </div>

              <!-- Vista semanal -->
              <div
                class="day-column"
                *ngFor="let day of weekDays; let i = index"
                [class.current-day]="i === 0"
                [class.hidden]="currentView === 'day'"
              >
                <div class="day-header">
                  <span class="day-name">{{ day.name }}</span>
                  <span class="day-date">{{ day.date }}</span>
                </div>
                <div class="day-slots">
                  <div
                    class="time-slot"
                    *ngFor="let hour of timeSlots"
                    (click)="selectTimeSlot(day, hour)"
                  >
                    <div
                      class="current-time-indicator"
                      *ngIf="i === 0 && hour === '13'"
                    ></div>
                    <div
                      class="event-indicator"
                      *ngIf="hasEvent(day, hour)"
                      [title]="
                        'Cita con ' +
                        getCoachName(day, hour) +
                        ' (' +
                        getCoachType(day, hour) +
                        ')'
                      "
                    >
                      <div class="event-details" *ngIf="hasEvent(day, hour)">
                        <span class="coach-name">{{
                          getCoachName(day, hour)
                        }}</span>
                        <span class="coach-type">{{
                          getCoachType(day, hour)
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Vista diaria -->
              <div class="day-column single-day" *ngIf="currentView === 'day'">
                <div class="day-header">
                  <div class="day-nav">
                    <button
                      class="day-nav-btn"
                      (click)="navigateDay(-1)"
                      [disabled]="selectedDayIndex === 0"
                    >
                      &#8592;
                    </button>
                    <div class="day-info">
                      <span class="day-name">{{ selectedDay?.name }}</span>
                      <span class="day-date">{{ selectedDay?.date }}</span>
                    </div>
                    <button
                      class="day-nav-btn"
                      (click)="navigateDay(1)"
                      [disabled]="selectedDayIndex === 6"
                    >
                      &#8594;
                    </button>
                  </div>
                </div>
                <div class="day-slots">
                  <div
                    class="time-slot"
                    *ngFor="let hour of timeSlots"
                    (click)="selectTimeSlot(selectedDay, hour)"
                  >
                    <div
                      class="current-time-indicator"
                      *ngIf="hour === '13'"
                    ></div>
                    <div
                      class="event-indicator"
                      *ngIf="hasEvent(selectedDay, hour)"
                      [title]="
                        'Cita con ' +
                        getCoachName(selectedDay, hour) +
                        ' (' +
                        getCoachType(selectedDay, hour) +
                        ')'
                      "
                    >
                      <div
                        class="event-details"
                        *ngIf="hasEvent(selectedDay, hour)"
                      >
                        <span class="coach-name">{{
                          getCoachName(selectedDay, hour)
                        }}</span>
                        <span class="coach-type">{{
                          getCoachType(selectedDay, hour)
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Vista Mensual -->
              <div class="month-calendar" [class.force-show-tablet]="true">
                <div class="month-header">
                  <button class="nav-btn" (click)="navigateMonth(-1)">
                    &#8592;
                  </button>
                  <div class="month-title">{{ currentMonthYear }}</div>
                  <button class="nav-btn" (click)="navigateMonth(1)">
                    &#8594;
                  </button>
                </div>

                <div class="calendar-body">
                  <div class="weekdays">
                    <div
                      class="weekday"
                      *ngFor="let day of ['D', 'L', 'M', 'M', 'J', 'V', 'S']"
                    >
                      {{ day }}
                    </div>
                  </div>

                  <div class="days-grid">
                    <div
                      class="day-cell"
                      *ngFor="let dayData of miniCalendarDays"
                      [class.other-month]="dayData.isOtherMonth"
                      [class.today]="dayData.isToday"
                      [class.has-event]="dayData.hasEvent"
                      [class.selected]="isSelectedDay(dayData)"
                      (click)="selectMiniCalendarDay(dayData)"
                    >
                      <span class="day-number">{{
                        dayData.day > 0 ? dayData.day : ""
                      }}</span>
                      <div class="event-indicator" *ngIf="dayData.hasEvent">
                        <span class="event-text">●</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Lista de Citas Programadas -->
          <div class="eventos-lista">
            <div class="eventos-content">
              <!-- Debug info -->
              <div *ngIf="eventsByDay.length === 0" class="no-events">
                No hay citas programadas
              </div>
              <div class="eventos-dia" *ngFor="let dayEvents of eventsByDay">
                <div class="dia-header">
                  <span class="dia-nombre"
                    >{{ dayEvents.dayName }}, {{ dayEvents.date }}</span
                  >
                  <button
                    class="dia-menu-btn"
                    (click)="toggleDayMenu(dayEvents.date)"
                  >
                    <span>⋮</span>
                  </button>
                </div>

                <div class="eventos-del-dia">
                  <div
                    class="evento-item"
                    *ngFor="let event of dayEvents.events"
                  >
                    <div class="evento-hora">{{ event.time }}</div>
                    <div
                      class="evento-linea"
                      [class]="getEventLineClass(event.type)"
                    ></div>
                    <div class="evento-info">
                      <div class="evento-tipo">{{ event.type }}</div>
                      <div class="evento-titulo">{{ event.title }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Calendario Mensual (Sidebar) - Solo visible en móvil -->
        <div class="calendario-mensual mobile-only">
          <div class="month-header">
            <div class="month-selector">
              <span class="month-year">{{ currentMonthYear }}</span>
              <span class="dropdown-arrow">▼</span>
            </div>
            <div class="month-nav">
              <button class="month-nav-btn" (click)="navigateMonth(-1)">
                &#8592;
              </button>
              <button class="month-nav-btn" (click)="navigateMonth(1)">
                &#8594;
              </button>
            </div>
          </div>

          <div class="mini-calendar">
            <div class="mini-calendar-header">
              <span>D</span>
              <span>L</span>
              <span>M</span>
              <span>M</span>
              <span>J</span>
              <span>V</span>
              <span>S</span>
            </div>
            <div class="mini-calendar-grid">
              <div
                class="mini-day"
                *ngFor="let dayData of miniCalendarDays; let i = index"
                [class.other-month]="dayData.isOtherMonth"
                [class.today]="dayData.isToday"
                [class.has-event]="dayData.hasEvent"
                [class.selected]="isSelectedDay(dayData)"
                (click)="selectMiniCalendarDay(dayData)"
              >
                {{ dayData.day > 0 ? dayData.day : "" }}
              </div>
            </div>
          </div>

          <!-- <div class="filtro-calendario">
            <h4>Filtrar por</h4>
            <div class="filtro-botones">
              <button class="filter-btn">Personal</button>
              <button class="filter-btn">Trabajo</button>
              <button class="filter-btn">Estudios</button>
              <button class="filter-btn">Coaching</button>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>

  <!-- Banner Academy Móvil -->
  <div class="academy-mobile-banner">
    <div class="academy-banner-content">
      <p class="academy-banner-text">DESCUBRE LO NUEVO EN ACADEMY</p>
      <button class="academy-banner-button" (click)="goToAcademy()">VER</button>
    </div>
  </div>

  <!-- Sección de Academy -->
  <div class="academy-section" *ngIf="cursos.length > 0">
    <div class="section-header">
      <h2>Phoenix Academy</h2>
      <div class="nav-buttons">
        <button class="btn-nav">&#8592;</button>
        <button class="btn-nav">&#8594;</button>
      </div>
    </div>

    <div class="academy-cards">
      <div class="course-card" *ngFor="let curso of cursos">
        <div class="course-stats">
          <span><i>👁️</i> {{ curso.vistas }} vistas</span>
          <span><i>⏱️</i> {{ curso.duracion }} min</span>
          <button class="btn-share"><i>🔗</i></button>
        </div>

        <div class="course-preview">
          <div
            class="course-image"
            [style.background-image]="'url(' + curso.imagen + ')'"
          >
            <!-- La imagen se muestra como background-image -->
          </div>
        </div>

        <div class="course-content">
          <h3>{{ curso.titulo }}</h3>
          <div class="course-categories">Educación • Autoconocimiento</div>

          <div class="course-actions">
            <button class="btn-play"><i>▶️</i> Ver</button>
            <button class="btn-save"><i>💾</i> Guardar</button>
          </div>
        </div>
      </div>
    </div>

    <div class="academy-cta">
      <button class="btn-academy">Ver todos los cursos</button>
    </div>
  </div>

  <!-- Sección de Blog -->
  <div class="blog-section" *ngIf="blog.length > 0">
    <h2>Blog</h2>

    <div class="blog-cards">
      <div class="blog-card" *ngFor="let entrada of blog">
        <div class="blog-image">
          <!-- Aquí iría la imagen del blog -->
        </div>

        <div class="blog-card-content">
          <h3>{{ entrada.titulo }}</h3>
          <p>{{ entrada.extracto }}</p>
          <a href="#">Leer más ></a>
        </div>
      </div>
    </div>

    <div class="blog-cta">
      <button class="btn-blog">Ir al blog</button>
    </div>
  </div>

  <!-- Footer -->
  <div class="footer">
    <div class="footer-content">
      <a target="_blank" [routerLink]="['/terms-conditions']"
        >Términos y condiciones</a
      >
      <a target="_blank" [routerLink]="['/privacy-policies']"
        >Política de privacidad</a
      >
      <a target="_blank" [routerLink]="['/contact-us']">Contacto</a>
    </div>
  </div>
</div>

<!-- Modal de detalles de cita -->
<div
  class="appointment-modal-overlay"
  *ngIf="showAppointmentModal"
  (click)="closeAppointmentModal()"
>
  <div class="appointment-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">
        Hora experto {{ selectedAppointment?.coach?.name }}
      </h3>
      <button class="modal-close-btn" (click)="closeAppointmentModal()">
        ×
      </button>
    </div>

    <div class="modal-content">
      <div class="meeting-info">
        <div class="meeting-time">
          <span class="time-label"
            >Hora experto {{ selectedAppointment?.coach?.name }}</span
          >
          <span class="time-value">{{ selectedAppointment?.time }}</span>
        </div>

        <div class="meeting-details">
          <div class="detail-item">
            <span class="detail-label">ID de reunión:</span>
            <span class="detail-value">{{ getMeetingId() }}</span>
          </div>
          <!-- <div class="detail-item">
            <span class="detail-label">Código de acceso:</span>
            <span class="detail-value">{{ getAccessCode() }}</span>
          </div> -->
        </div>

        <div class="invitation-message">
          <p>
            Expertos Phoenix le está invitando a una reunión de Meet programada.
            Únase a la reunión de Meet con el siguiente link.
          </p>
        </div>

        <div class="meeting-link">
          <div class="meet-icon">📹</div>
          <span class="link-text">{{ getMeetingLink() }}</span>
        </div>

        <div class="action-buttons">
          <button class="btn-join-meeting" (click)="joinMeeting()">
            Unirse a la reunión
          </button>
          <button class="btn-copy-link" (click)="copyMeetingLink()">
            Copiar enlace
          </button>
          <button class="btn-send-email" (click)="sendAppointmentInfoByEmail()">
            📧 Enviar por email
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Botón flotante - Solo visible cuando isCompleteInfo es true -->
<div *ngIf="user?.isCompleteInfo" class="floating-button-container">
  <button
    class="floating-button"
    (click)="onFloatingButtonClick()"
    [title]="getFloatingButtonTooltip()"
  >
    <i class="fas fa-lightbulb"></i>
  </button>
</div>

<!-- Botón de prueba para el modal Executive -->
<!-- <div class="test-button-container">
    <button class="test-button" (click)="testExecutiveModal()" 
            title="Probar modal Executive">
      🧪 Test Modal
    </button>
  </div> -->

<!-- Modal de video -->
<app-video-modal
  [isVisible]="showVideoModal"
  (closeDialogEvent)="closeVideoModal()"
>
</app-video-modal>

<!-- Modal de Lista de Espera -->
<div *ngIf="showWaitlistModal" class="waitlist-modal-overlay">
  <div class="waitlist-modal" (click)="$event.stopPropagation()">
    <div class="waitlist-modal-content">
      <div class="modal-header-text">
        <p>Descubre todo lo que Phoenix Professional tiene para ti</p>
      </div>
      <!-- Sección de Video -->
      <div class="video-section">
        <div class="video-container">
          <!-- Usar nuestro componente reutilizable YouTube Player -->
          <div #youtubePlayer>
            <app-youtube-player
              *ngIf="getProfessionalVideoId()"
              [videoId]="getProfessionalVideoId()"
              [params]="getVideoParams()"
            ></app-youtube-player>
          </div>

          <!-- Mensaje de error si no hay video ID -->
          <div *ngIf="!getProfessionalVideoId()" class="error-message">
            <p>No se pudo cargar el video profesional</p>
          </div>
        </div>
      </div>

      <!-- Header Text -->
      <div class="modal-header-text">
        <h2>
          Únete a nuestra lista de espera para convertirte en Phoenix
          Professional
        </h2>
        <p>
          Sé el primero en acceder a todas las increíbles actividades que
          tenemos para ti
        </p>
      </div>

      <!-- Formulario -->
      <form class="waitlist-form" (ngSubmit)="submitWaitlistForm()">
        <div class="form-row">
          <div class="form-group">
            <label>Nombre <span class="required">*</span></label>
            <input
              type="text"
              [(ngModel)]="waitlistForm.nombre"
              name="nombre"
              placeholder="Ingrese nombre"
              required
            />
          </div>

          <div class="form-group">
            <label>Apellido <span class="required">*</span></label>
            <input
              type="text"
              [(ngModel)]="waitlistForm.apellido"
              name="apellido"
              placeholder="Ingrese apellido"
              required
            />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>Teléfono <span class="required">*</span></label>
            <input
              type="tel"
              [(ngModel)]="waitlistForm.telefono"
              name="telefono"
              placeholder="Ingrese teléfono"
              required
            />
          </div>

          <div class="form-group">
            <label>Correo electrónico <span class="required">*</span></label>
            <input
              type="email"
              [(ngModel)]="waitlistForm.correoElectronico"
              name="correoElectronico"
              placeholder="Ingrese correo"
              required
            />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>Provincia <span class="required">*</span></label>
            <select
              [(ngModel)]="waitlistForm.provincia"
              name="provincia"
              (change)="onProvinciaChange()"
              required
            >
              <option value="">Ingrese provincia</option>
              <option *ngFor="let provincia of provincias" [value]="provincia">
                {{ provincia }}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Distrito <span class="required">*</span></label>
            <select
              [(ngModel)]="waitlistForm.distrito"
              name="distrito"
              [disabled]="!waitlistForm.provincia"
              required
            >
              <option value="">Ingrese distrito</option>
              <option
                *ngFor="let distrito of getDistritosByProvincia()"
                [value]="distrito"
              >
                {{ distrito }}
              </option>
            </select>
          </div>
        </div>

        <button
          type="submit"
          class="register-button"
          [disabled]="!isWaitlistFormValid() || isSubmittingWaitlist"
        >
          <span *ngIf="!isSubmittingWaitlist">Registrarme</span>
          <span *ngIf="isSubmittingWaitlist">Registrando...</span>
        </button>
      </form>

      <!-- Sección de Beneficios -->
      <div class="benefits-section">
        <h3>Descubre todo lo que Phoenix Professional tiene para ti</h3>
        <div class="benefits-list">
          <div class="benefit-item">
            <span class="check-icon">✓</span>
            <span>Primer beneficio</span>
          </div>
          <div class="benefit-item">
            <span class="check-icon">✓</span>
            <span>Segundo beneficio</span>
          </div>
          <div class="benefit-item">
            <span class="check-icon">✓</span>
            <span>Tercer beneficio</span>
          </div>
          <div class="benefit-item">
            <span class="check-icon">✓</span>
            <span>Cuarto beneficio</span>
          </div>
        </div>
      </div>

      <!-- Botón de cerrar -->
      <button class="close-button" (click)="closeWaitlistModal()">
        <span>×</span>
      </button>
    </div>
  </div>
</div>
